"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreferedLanguage = void 0;
const react_1 = require("react");
const i18n_js_1 = __importDefault(require("i18n-js"));
const language_1 = require("./language");
const usePreferedLanguage = () => {
    const { language } = (0, language_1.useLanguage)();
    (0, react_1.useEffect)(() => {
        i18n_js_1.default.locale = language;
    }, [language]);
};
exports.usePreferedLanguage = usePreferedLanguage;
//# sourceMappingURL=use_prefered_language.js.map